// extracted by mini-css-extract-plugin
export default {"component":"Mobile_ConferenceEditNotesPage_component__6B--b","textAreaNotes":"Mobile_ConferenceEditNotesPage_textAreaNotes__Ufm3r"};